document.addEventListener('DOMContentLoaded', () => {
	const topBar = document.querySelector('.section.header-1 .top-bar');
	const fire_sale_component = document.querySelector('.component.fire-sale');
	if (fire_sale_component) {
		fire_sale_component.style.display = 'flex';

		// --- Rendering Text Logic (Moved from AJAX) ---
		const renderFireSaleText = () => {
			const textElement = document.querySelector('.component.fire-sale.fire-sale-1 .text');
			const saleData = (typeof origoComponentFireSaleConfig !== 'undefined') ? origoComponentFireSaleConfig.saleData : null;

			if (!textElement || !saleData) return;

			const now = new Date();

			if (fireSaleState.isCurrentSaleWeek) {
				if (saleData.from_start_text) {
					textElement.innerHTML = saleData.from_start_text;
				}
			} else {
				if (saleData.until_start_text) {
					textElement.innerHTML = saleData.until_start_text;
				} else if (fireSaleState.saleStart) {
					const isSameDay = now.getFullYear() === fireSaleState.saleStart.getFullYear() &&
						now.getMonth() === fireSaleState.saleStart.getMonth() &&
						now.getDate() === fireSaleState.saleStart.getDate();

					if (isSameDay) {
						textElement.innerHTML = 'Onze leegverkoop start vandaag!';
					} else {
						textElement.innerHTML = `Onze leegverkoop start op ${new Date(fireSaleState.saleStart).toLocaleDateString('nl-NL', {
							weekday: 'long', day: 'numeric', month: 'long'
						})}`;

						document.querySelector('.component.fire-sale .countdown')?.remove();
					}
				}
			}

			if (!saleData.countdown || saleData.countdown === 'false') {
				document.querySelector('.component.fire-sale .countdown')?.remove();
			}
		};

		// Initial State Calculation & Render
		updateFireSaleState();
		renderFireSaleCountdown();
		renderFireSaleText(); // Render text immediately

		// Reveal component
		const el = document.querySelector('.component.fire-sale.fire-sale-1');
		if (el) el.style.opacity = '1';

		// Optional: Fetch API data (Client-side fetch if configured)
		if (typeof origoComponentFireSaleConfig !== 'undefined' && origoComponentFireSaleConfig.apiUrl) {
			if (window.OrigoApi && window.OrigoApi.fetchCached) {
				window.OrigoApi.fetchCached(origoComponentFireSaleConfig.apiUrl)
					.then(data => {
						fireSaleApiData = data;
						updateFireSaleState();
						renderFireSaleCountdown();
						renderFireSaleText(); // Re-render text if data changed
					})
					.catch(err => console.error("Fire sale API fetch failed", err));
			}
		}

		// Set Intervals
		setInterval(renderFireSaleCountdown, 1000);
		setInterval(() => {
			updateFireSaleState();
			renderFireSaleText(); // Check if text needs update (e.g. crossing start time)
		}, 60000);

	}
});

let fireSaleApiData = null;

// Global State for Fire Sale
const fireSaleState = {
	targetDate: null,
	businessDaysLeft: null,
	isCurrentSaleWeek: false,
	saleStart: null,
	isActive: true
};

// --- Helper Functions ---

// fetchWithRetries removed -> using window.OrigoApi

const parseDateString = (dateStr) => {
	if (!dateStr) return null;
	if (dateStr.includes(' ')) {
		const [datePart, timePart] = dateStr.split(' ');
		const [year, month, day] = datePart.split('-').map(Number);
		const [hours, minutes] = timePart.split(':').map(Number);
		return new Date(year, month - 1, day, hours, minutes, 0);
	}
	return new Date(dateStr);
};

const calculateBusinessDaysLeft = (schedule, now) => {
	if (!Array.isArray(schedule)) return 0;
	const todayStr = now.toISOString().split('T')[0];
	let count = 0;

	for (const item of schedule) {
		if (!item.is_open) continue;

		// Handle API property mismatch (date vs full_date)
		const itemDate = item.date || item.full_date;
		if (!itemDate) continue;

		if (itemDate > todayStr) {
			count++;
		} else if (itemDate === todayStr && item.close_time) {
			const [cHours, cMinutes] = item.close_time.split(':').map(Number);
			const closeDate = new Date(now);
			closeDate.setHours(cHours, cMinutes, 0, 0);
			if (now < closeDate) count++;
		}
	}
	return count;
};

const getWeeklyScope = (schedule, now) => {
	if (!Array.isArray(schedule) || schedule.length === 0) return null;

	const getSunday = (d) => {
		const date = new Date(d);
		const day = date.getDay();
		const diff = date.getDate() - day;
		date.setDate(diff);
		date.setHours(0, 0, 0, 0);
		return date;
	};

	const filterWeek = (startOfWeek) => {
		const nextWeek = new Date(startOfWeek);
		nextWeek.setDate(nextWeek.getDate() + 7);
		return schedule.filter(d => {
			const dateStr = d.date || d.full_date;
			if (!dateStr) return false;
			const date = parseDateString(dateStr + ' 00:00');
			return date >= startOfWeek && date < nextWeek;
		});
	};

	let currentWeekStart = getSunday(now);

	for (let w = 0; w < 4; w++) {
		let weekDays = filterWeek(currentWeekStart);
		weekDays.sort((a, b) => (a.date || a.full_date).localeCompare(b.date || b.full_date));

		if (weekDays.length > 0) {
			// FIX: Do not segment. Identify ALL open business days in this week.
			const openDays = weekDays.filter(d => d.is_open || (d.open_time && d.close_time));

			if (openDays.length > 0) {
				const first = openDays[0];
				const last = openDays[openDays.length - 1];

				const firstDate = first.date || first.full_date;
				const lastDate = last.date || last.full_date;

				const start = parseDateString(`${firstDate} ${first.open_time || '08:00'}`);
				const end = parseDateString(`${lastDate} ${last.close_time || '16:30'}`);

				if (start && end && now < end) {
					return {
						scopeStart: start,
						scopeEnd: end,
						scopeDays: openDays,
						isCurrentSaleWeek: (now >= start && now <= end)
					};
				}
			}
		}
		currentWeekStart.setDate(currentWeekStart.getDate() + 7);
	}
	return null;
};

// --- State Calculation Function (Heavy) ---

function updateFireSaleState() {
	const now = new Date();
	let targetDate = null;
	let businessDaysLeft = null;
	let saleStart = null;
	let saleEnd = null;
	let isCurrentSaleWeek = false;

	// Determine Schedule Source: Favor API data > PHP data
	let schedule = null;

	if (fireSaleApiData && fireSaleApiData.days) {
		schedule = fireSaleApiData.days;
	} else if (typeof origoSaleData !== 'undefined' && origoSaleData.schedule) {
		schedule = origoSaleData.schedule;
	}

	// Calculate Scope
	const weeklyScope = getWeeklyScope(schedule, now);

	if (weeklyScope?.scopeStart && weeklyScope?.scopeEnd) {
		saleStart = weeklyScope.scopeStart;
		saleEnd = weeklyScope.scopeEnd;
		businessDaysLeft = calculateBusinessDaysLeft(weeklyScope.scopeDays, now);
		isCurrentSaleWeek = weeklyScope.isCurrentSaleWeek;
	} else if (typeof origoComponentFireSaleConfig !== 'undefined' && origoComponentFireSaleConfig.saleData) {
		// Fallback to PHP config dates
		const saleData = origoComponentFireSaleConfig.saleData;
		saleStart = parseDateString(saleData.start_date);
		saleEnd = parseDateString(saleData.end_date);
		if (saleData.days_left !== undefined) businessDaysLeft = parseInt(saleData.days_left);

		if (saleStart && saleEnd) {
			isCurrentSaleWeek = (now >= saleStart && now <= saleEnd);
		}
	}

	// Determine Target & Status
	if (saleStart && saleEnd) {
		if (isCurrentSaleWeek) {
			targetDate = saleEnd;
		} else if (now < saleStart) {
			if (businessDaysLeft === 1) {
				targetDate = saleEnd;
				isCurrentSaleWeek = true;
			} else {
				targetDate = saleStart;
				businessDaysLeft = null;
			}
		} else {
			targetDate = saleEnd;
			businessDaysLeft = 0;
		}
	}

	fireSaleState.targetDate = targetDate;
	fireSaleState.businessDaysLeft = businessDaysLeft;
	fireSaleState.isCurrentSaleWeek = isCurrentSaleWeek;
	fireSaleState.saleStart = saleStart;

	// Determine Visibility Logic based on remaining time (updated in render loop mostly, but check here too)
	fireSaleState.isActive = !(targetDate && (targetDate - now) <= 0);
}

// --- Render Function (Lightweight) ---

const getTodayClosingTime = (schedule, now) => {
	if (!Array.isArray(schedule)) return null;
	const todayStr = now.toISOString().split('T')[0];
	const item = schedule.find(d => {
		const dDate = d.date || d.full_date;
		return dDate === todayStr;
	});

	if (item && item.close_time && (item.is_open || (item.open_time && item.close_time))) {
		const [h, m] = item.close_time.split(':').map(Number);
		const close = new Date(now);
		close.setHours(h, m, 0, 0);
		return close;
	}
	return null;
};

function renderFireSaleCountdown() {
	if (!fireSaleState.isActive) {
		const component = document.querySelector('.component.fire-sale.fire-sale-1');
		if (component) component.style.display = 'none';
		return;
	}

	const now = new Date();
	const targetDate = fireSaleState.targetDate;

	// Get basic remaining ms for days calc
	const remainingMs = targetDate ? Math.max(0, targetDate - now) : 0;

	// Check if configured to hide
	if (remainingMs === 0 && targetDate && (targetDate - now) <= 0) {
		const component = document.querySelector('.component.fire-sale.fire-sale-1');
		if (component) component.style.display = 'none';
		return;
	}

	let days = Math.floor(remainingMs / 86400000);

	// Override hours/min/sec to be "Time until TODAY's close"

	let hours = Math.floor((remainingMs % 86400000) / 3600000);
	let minutes = Math.floor((remainingMs % 3600000) / 60000);
	let seconds = Math.floor((remainingMs % 60000) / 1000);

	// Determine schedule to use
	let schedule = fireSaleApiData ? fireSaleApiData.days : (typeof origoSaleData !== 'undefined' ? origoSaleData.schedule : []);

	const todayClose = getTodayClosingTime(schedule, now);
	if (todayClose && todayClose > now) {
		const diff = todayClose - now;
		hours = Math.floor(diff / 3600000);
		minutes = Math.floor((diff % 3600000) / 60000);
		seconds = Math.floor((diff % 60000) / 1000);
	}

	// Render
	const fire_sale_countdown = document.querySelector('.component.fire-sale .countdown');
	if (fire_sale_countdown) {
		const setVal = (cls, val) => fire_sale_countdown.querySelector(`.${cls} .value`).textContent = String(val).padStart(2, '0');
		setVal('days', days);
		setVal('hours', hours);
		setVal('minutes', minutes);
		setVal('seconds', seconds);
	}
}
